module.exports = __webpack_public_path__ + "fonts/NotoSans-Medium.5ddf8f3.ttf";